import Vue from 'vue';

export default Vue.component('ed-list-item', {
  name: 'ed-list-item',
  props: {
    action: {
      type: Boolean,
      default: false,
    },
    borderless: {
      type: Boolean,
      default: false,
    },
  },
  methods : {
    onClickButton() {
      this.$emit('click');
    }
  }
});